//for action and buttons both
export default {
    msg_404_title: {
        en: "Page Not found",
        bn: "লিংক খুঁজে পাওয়া যায়নি"
    },
    msg_404_message: {
        en: "It's look like you are in wrong page. Make sure you have copied the link properly.",
        bn: "দেখে মনে হচ্ছে আপনি ভুল লিংকে আছেন। নিশ্চিত করুন যে আপনি লিঙ্কটি সঠিকভাবে কপি  করেছেন।"
    },
    msg_server_error_title: {
        en: "Internet/Server Problem",
        bn: "ইন্টারনেট/সার্ভার সমস্যা"
    },
    msg_server_error_message: {
        en: "Please Check your Internet Connection. Wait some moment and Try again. You may contact with admin.",
        bn: "আপনার ইন্টারনেট সংযোগটি পরীক্ষা করুন । কিছুক্ষণ অপেক্ষা করে আবার চেষ্টা করুন, অথবা আপনি অ্যাডমিনের সাথে যোগাযোগ করুন।"
    },
    msg_file_server_error_title: {
        en: "File Server/ Internet Problem",
        bn: "ফাইল সার্ভার/ইন্টারনেট সমস্যা"
    },
    msg_file_server_error_message: {
        en: "Problem uploading file. Please Check your Internet Connection. Wait some moment and Try again. You may contact with admin.",
        bn: "ফাইল আপলোড সমস্যা । আপনার ইন্টারনেট সংযোগটি পরীক্ষা করুন । কিছুক্ষণ অপেক্ষা করে আবার চেষ্টা করুন, অথবা আপনি অ্যাডমিনের সাথে যোগাযোগ করুন।"
    },
    msg_access_deny_title: {
        en: "Access Deny",
        bn: "প্রবেশ অনুমতি নাই"
    },
    msg_access_deny_message: {
        en: "Sorry, you are not authorized to access this page. You may contact with system admin.",
        bn: "দুঃখিত, এই পৃষ্ঠায় আপনার প্রবেশ অনুমতি নাই। আপনি অ্যাডমিনের সাথে যোগাযোগ করুন।"
    },
    msg_site_offline_title: {
        en: "Site is offline",
        bn: "সাইট অফলাইন"
    },
    msg_site_offline_message: {
        en: "Site is currently offline. Wait some moment and refresh your browser. You may contact with system admin.",
        bn: "সাইটটি বর্তমানে অফলাইনে রয়েছে। কিছুক্ষণ অপেক্ষা করুন এবং আপনার ব্রাউজারটি রিফ্রেশ করুন, অথবা আপনি অ্যাডমিনের সাথে যোগাযোগ করুন।"
    },

    msg_save_failed_title: {
        en: 'Failed',
        bn: 'ব্যর্থ',
    },
    msg_save_failed: {
        en: 'Fail to save',
        bn: 'সংরক্ষণ করতে ব্যর্থ হয়েছে',
    },
    msg_success_title: {
        en: 'Success',
        bn: 'সাফল্য',
    },
    msg_success_saved: {
        en: 'Successfully saved',
        bn: 'সফলভাবে সংরক্ষিত হয়েছে',
    },
    msg_response_error_title: {
        en: 'Response Error',
        bn: 'রেসপন্স এরর।',
    },
    msg_response_error_body: {
        en: 'Internet/ Server Error',
        bn: 'ইন্টারনেট/ সার্ভার এরর।',
    },
    msg_contact_with_admin: {
        en: 'Please contact with your System Admin.',
        bn: 'সিস্টেম এডমিনের সাথে যোগাযোগ করুণ।',
    },
    msg_data_not_found: {
        en: 'Data/ content not found.',
        bn: 'তথ্য/ বিষয়বস্তু খুঁজে পাওয়া যায়নি।',
    },
    msg_item_not_found: {
        en: 'Data not found.',
        bn: 'তথ্য খুঁজে পাওয়া যায়নি।',
    },
    // Deny or, No Access
    msg_loading_access_deny_header: {
        en: 'Access Denied',
        bn: 'প্রবেশ নিষেধ',
    },
    msg_loading_access_deny_subheader: {
        en: 'You are Logged out or, may have no access',
        bn: 'আপনার প্রবেশধিকার নেই'
    },
    msg_loading_access_deny_info: {
        en: 'You don\'t have permission to this page. Contact with your Admin.',
        bn: '',
    },
    msg_invalid_data: {
        en: 'Invalid Data. Contact with your Admin.',
        bn: '',
    },
}